import useAnimationReduced from './animationReducedAtom';

export * from './animationReducedAtom';

export default useAnimationReduced;
